import { Component, Input, Output, EventEmitter } from '@angular/core';


export interface Term {
  title: string;
  childrens: Array<any>;
}

@Component({
  selector: 'fcp-staging-filter',
  templateUrl: './staging-filter.component.html',
  styleUrls: ['./staging-filter.component.scss']
})
export class StagingFilterComponent {

  @Input() public terms: Array<Term>;
  @Input() public canShowSelectedTerm: boolean;

  @Output() public searchAction: EventEmitter<string> = new EventEmitter();
  @Output() public clearAction: EventEmitter<Array<any>> = new EventEmitter();
  @Output() public termWasSeleted: EventEmitter<string> = new EventEmitter();

  public selectedTerm: any;

  constructor() { }

  public clicked(term): void {
    this.searchAction.emit(term);
  }

  public clearResults(): void {
    this.terms = [];
    this.selectedTerm = null;
    this.clearAction.emit([]);
  }

  public selectTerm(term) {
    this.terms = [];
    this.selectedTerm = this.canShowSelectedTerm ? term.childrens : term;
    this.termWasSeleted.emit(term);
  }

  public scrollToTop() {
    window.scrollTo(0,0);
  }
}
